<template>
    <Invoice :kind="1"></Invoice>
</template>

<script>
import Invoice from './Invoice';
export default {
    name: "DispersedIncomeInvoice",
    components: { Invoice }
}
</script>
